<template>
  <CRow class="pl-5 pr-5 mb-5 mt-4 blockPlans justify-content-md-center">
    <div v-for="pn in planFeaturesDynamic" :key="pn.planId">
      <CCol sm="12">
        <div :class="{ blockPlanRecommendedDetails: pn.isRecommended, blockPlanDetails: !pn.isRecommended }">
          <div v-if="pn.isRecommended" class="recommended">{{ $t('card.plan.recommended') }}</div>
          <div class="blockTitle mt-2">{{ handlePlanNameCard(pn.planName) }}</div>
          <div v-if="pn.planName == planNames.free" class="h-30 mt-2"></div>
          <div v-if="pn.planName == planNames.payAsYouGo" class="h-30 mt-2 font-weight-bold">{{ $t('card.plan.payAsYouGoSubtitle') }}</div>
          <div>
            <div v-if="paymentPeriod == 1 && pn.monthPrice" class="blockSubTitle mt-2">{{ pn.monthPrice }} € / {{ $t('card.plan.month') }}</div>
            <div v-if="paymentPeriod == 3 && pn.monthPrice" class="blockSubTitle mt-2">{{ pn.monthPrice }} € / {{ $t('card.plan.month') }}</div>
            <div v-if="paymentPeriod == 3 && pn.annualWithoutDiscount" class="blockSaveInfo">
              {{ $t('card.plan.you-pay') }} {{ pn.annualWithoutDiscount }} € / {{ $t('card.plan.year') }}
            </div>
          </div>
          <div>
            <!-- #region Força renderização com duplicata de CButton pois pn.isAvaiable não é reativo ao v-c-tooltip devido ao $set este component precisa ser refatorado -->
            <CButton
              v-if="pn.isAvaiable && !pn.currentPlan"
              :key="'btn-started-' + pn.planId"
              @click="selectPlan(2, pn)"
              :disabled="!pn.isAvaiable || !isOrganizationApproved"
              class="mt-5 outline"
              :class="{
                btnRecommendedPlan: pn.isRecommended && pn.visible,
                btnOptionPlan: pn.isAvaiable && !pn.isRecommended,
                btnCurrentPlan: !pn.isAvaiable,
              }"
            >
              {{ $t('card.plan.details.btn.started') }}
            </CButton>
            <CButton
              v-if="!pn.isAvaiable && !pn.currentPlan"
              :key="'btn-downgrade-' + pn.planId"
              @click="selectPlan(2, pn)"
              :disabled="!pn.isAvaiable || !isOrganizationApproved"
              class="mt-5 outline"
              v-c-tooltip="{ content: $t('card.plan.details.tooltip.downgrade'), placement: 'top' }"
              :class="{
                btnRecommendedPlan: pn.isRecommended && pn.visible,
                btnOptionPlan: pn.isAvaiable && !pn.isRecommended,
                btnCurrentPlan: !pn.isAvaiable,
              }"
            >
              {{ $t('card.plan.details.btn.started') }}
            </CButton>
            <!-- #endregion Força renderização pois pn.isAvaiable não estava reativo -->

            <CButton v-if="pn.currentPlan && !isOrganizationPlanSuspended" class="mt-5 btnCurrentPlan" disabled>
              {{ $t('card.plan.details.btn.current') }}
            </CButton>
            <CButton
              v-if="pn.currentPlan && isOrganizationPlanSuspended"
              @click="selectPlan(2, pn)"
              :disabled="!isOrganizationApproved"
              class="mt-5 outline btnOptionPlan"
            >
              {{ $t('card.plan.details.btn.renew') }}
            </CButton>
          </div>
          <div class="blockFeatureTitle mt-4 mb-3">{{ $t(pn.blockTitle) }}</div>
          <div class="blockFeatures mt-2" v-for="av in pn.available" :key="`available-${av.id}`">
            <CIcon class="checkMark mr-2" name="checkMark" :height="15" viewBox="0 0 32 32" />
            <span>{{ $t(av.featureName, { maxEmailsPerMonth: (maxAudience * 4).toLocaleString() }) }}</span>
          </div>
          <div class="blockFeatures mt-2" v-for="ntav in pn.notAvailable" :key="`notAvailable-${ntav.id}`">
            <CIcon class="refused mr-2" name="cross" :height="14" viewBox="0 0 32 32" />
            {{ $t(ntav.featureName) }}
          </div>
        </div>
      </CCol>
    </div>
  </CRow>
</template>

<script>
import { PLAN_FEATURES } from '@/views/plansSubscriptions/constants'
import { planType } from '@/utils/enumsUtils.js'

const planTierEnum = {
  MOUNTH: 1,
  YEAR: 3,
}

const planNames = {
  free: 'Free',
  starter: 'Starter',
  professional: 'Professional',
  business: 'Business',
  payAsYouGo: 'PayAsYouGo',
}

export default {
  name: 'CardPlanDetails',
  components: {},
  props: {
    plans: {
      type: Array,
      default: () => [],
    },
    plansCatalog: {
      type: Array,
      default: () => [],
    },
    currentPlan: {
      type: Object,
      default: () => {},
    },
    isOrganizationApproved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      planFeatures: [
        {
          blockTitle: 'planSubscriptions.free.everythingYouGet',
          available: PLAN_FEATURES.free.available,
          notAvailable: PLAN_FEATURES.free.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: true,
          isFree: false,
          isRecommended: false,
          planName: planNames.free,
          planId: null,
          selectedTierId: null,
          visible: true,
        },
        {
          blockTitle: 'planSubscriptions.starter.everythingYouGet',
          available: PLAN_FEATURES.starter.available,
          notAvailable: PLAN_FEATURES.starter.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: false,
          planName: planNames.starter,
          planId: null,
          selectedTierId: null,
          visible: false,
        },
        {
          blockTitle: 'planSubscriptions.professional.everythingYouGet',
          available: PLAN_FEATURES.professional.available,
          notAvailable: PLAN_FEATURES.professional.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: true,
          planName: planNames.professional,
          planId: null,
          selectedTierId: null,
          visible: false,
        },
        {
          blockTitle: 'planSubscriptions.payAsYouGo.everythingYouGet',
          available: PLAN_FEATURES.payAsYouGo.available,
          notAvailable: PLAN_FEATURES.payAsYouGo.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: false,
          planName: planNames.payAsYouGo,
          planId: null,
          selectedTierId: null,
          visible: false,
        },
        /* {
          blockTitle: 'Everything you get with Business:',
          available: [
            'Platform Users up to 3 users',
            // 'Sub accounts up to 10 account',
            'e-mails/month',
            '10 campaign templates',
            // '5 automation flow',
            'E-mail support',
            'HTML Template import',
            'Template Premium',
          ],
          notAvailable: [],
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: false,
          planName: 'Business',
          planId: null,
          selectedTierId: null,
          visible: false,
        }, */
      ],
      planNames,
      plansNamesToShow: [planNames.starter, planNames.professional, planNames.business, planNames.payAsYouGo],
      isFree: true,
    }
  },
  beforeMount() {
    this.updatePlanOptions()
  },
  methods: {
    selectPlan(step, selectedPlan) {
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedPlanName', data: selectedPlan.planName })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedPlanId', data: selectedPlan.planId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedTierId', data: selectedPlan.selectedTierId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'periodPlanTierPriceId', data: selectedPlan.periodPlanTierPriceId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'mount', data: selectedPlan.monthPrice })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedPlan', data: selectedPlan })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'maxStep', data: step })

      if (planType(selectedPlan.planType) === planType(5)) {
        this.$router.push({
          name: 'manage-balance',
          query: {
            selectedPlanId: selectedPlan.planId,
          },
        })

        return
      }
      this.$store.dispatch('backOffice/steps/setCurrentStep', step)
    },

    updatePlanOptions() {
      let planName = this.currentPlan.name
      let currentRecipients = this.currentPlan.planTiers?.maxAudienceRecipients || 25 // Caso seja o plano Free
      let currentPeriod = this.currentPlan.planTiers?.periodPlanTierPrice.paymentPeriod || 0 // Caso seja o plano Free

      this.plansNamesToShow.forEach((name) => {
        let fullPrice = this.getPriceInPlanCatalog(name)
        let selectedTier = this.getTierInPlanCatalog(name)

        let mounthPrice = null
        let anualPrice = null

        this.isFree = false // TODO: ajustar checagem de plano

        let itemIndex = this.planFeatures.findIndex((x) => x.planName == name)

        /*
         * ? Essa propriedade valida se o plano está disponível
         * ? caso não haja preço ou tier, o plano não estará disponível
         */
        let isAvaiable = fullPrice != null && selectedTier != null

        const plan = this.getPlanByName(name)

        const isPlanTypePayAsYouGo = plan?.planType ? planType(plan.planType) === planType(5) : false

        let isCurrentPlan

        if (!isPlanTypePayAsYouGo) {
          if (!isAvaiable) {
            fullPrice = this.getPriceByPlanNameAndMaxAudience(name)
            selectedTier = this.getPriceIdByPlanNameAndMaxAudience(name)
            mounthPrice = selectedTier.planPeriod == planTierEnum.MOUNTH ? fullPrice : fullPrice / 12
            anualPrice = selectedTier.planPeriod == planTierEnum.YEAR ? fullPrice : null
          } else {
            mounthPrice = selectedTier.planPeriod == planTierEnum.MOUNTH ? fullPrice : fullPrice / 12
            anualPrice = selectedTier.planPeriod == planTierEnum.YEAR ? fullPrice : null
          }
          isCurrentPlan =
            selectedTier.maxAudienceRecipients == currentRecipients &&
            selectedTier?.planPeriod == currentPeriod &&
            planName?.toLowerCase() == name.toLowerCase()
        } else {
          isCurrentPlan = planName?.toLowerCase() == name.toLowerCase()
          isAvaiable = planType(this.currentPlan.planType) !== planType(2)
          const paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod

          const matchedTier = plan.planTiers.find((tier) => tier.periodPlanTierPrice.paymentPeriod == paymentPeriod)
          selectedTier = {
            tierId: matchedTier.periodPlanTierPrice.planTierId,
            periodPlanTierPriceId: matchedTier?.periodPlanTierPrice.id,
          }
        }

        let newValue = {
          ...this.planFeatures[itemIndex],
          planId: plan.id,
          monthPrice: mounthPrice?.toFixed(1),
          annualWithoutDiscount: anualPrice?.toFixed(2),
          annualPrice: anualPrice?.toFixed(2),
          currentPlan: isCurrentPlan,
          isFree: this.isFree,
          selectedTierId: selectedTier?.tierId,
          periodPlanTierPriceId: selectedTier?.periodPlanTierPriceId,
          visible: true,
          isAvaiable,
          planType: plan.planType,
        }

        this.$set(this.planFeatures, itemIndex, newValue)
      })
    },

    getPriceByPlanNameAndMaxAudience(planName) {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plans.find((item) => item.name === planName)
      let planTier = plan.planTiers.find(
        (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
      )
      if (typeof planTier != 'undefined') {
        return planTier.periodPlanTierPrice.price
      }
      return
    },

    getPriceIdByPlanNameAndMaxAudience(planName) {
      if (planName == this.planNames.free) {
        return null
      }
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plans.find((item) => item.name === planName)
      let planTier = plan.planTiers.find(
        (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
      )
      if (typeof planTier != 'undefined') {
        return {
          maxAudienceRecipients: planTier.maxAudienceRecipients,
          planPeriod: planTier.periodPlanTierPrice.paymentPeriod,
          tierId: planTier.periodPlanTierPrice.planTierId,
          periodPlanTierPriceId: planTier.periodPlanTierPrice.id,
        }
      }
      return
    },

    getPriceInPlanCatalog(planName) {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plansCatalog.find((item) => item.name === planName)

      if (plan) {
        let planTier = plan.planTiers.find(
          (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
        )

        if (typeof planTier != 'undefined') {
          return planTier.periodPlanTierPrice.price
        }
        return null
      } else return null
    },

    getTierInPlanCatalog(planName) {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plansCatalog.find((item) => item.name === planName)

      if (plan) {
        let planTier = plan.planTiers.find(
          (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
        )
        if (typeof planTier != 'undefined') {
          return {
            maxAudienceRecipients: planTier.maxAudienceRecipients,
            planPeriod: planTier.periodPlanTierPrice.paymentPeriod,
            tierId: planTier.periodPlanTierPrice.planTierId,
            periodPlanTierPriceId: planTier.periodPlanTierPrice.id,
          }
        }
        return null
      } else return null
    },

    getPlanByName(planName) {
      let plan = this.plans.find((item) => item.name === planName)
      return plan
    },

    getCurrentPlanPriceByPlanIdAndMaxAudience() {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let currentPlanDetails = this.plans.find((it) => it.name == this.currentPlan.name)
      if (this.currentPlan.name == this.planNames.free) {
        return null
      }
      let planTier = currentPlanDetails.planTiers.find(
        (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
      )
      if (typeof planTier != 'undefined') {
        return planTier.periodPlanTierPrice.price
      }
      return

      //return this.currentPlan.planTiers.periodPlanTierPrice.price
    },

    applyDiscount(value) {
      let discount = value * 0.1
      let newValue = value - discount
      return newValue.toFixed(1)
    },

    handlePlanNameCard(planName) {
      if (planName == this.planNames.payAsYouGo) return 'Pay As You Go'
      return planName
    },
  },

  watch: {
    maxAudience() {
      this.updatePlanOptions()
    },
    paymentPeriod() {
      this.updatePlanOptions()
    },
  },
  computed: {
    planFeaturesDynamic() {
      // Ativa exibição do plano Free apenas se a organization pertencer ao mesmo
      const planFeaturesWithoutFree = this.planFeatures.filter((planFeature) => planFeature.planName !== this.planNames.free)

      return this.currentPlan.name == this.planNames.free ? this.planFeatures : planFeaturesWithoutFree
    },
    paymentPeriod() {
      return this.$store.state.backOffice.steps.paymentPeriod
    },

    selectedAudience() {
      return this.$store.state.backOffice.steps.maxAudience
    },

    maxAudience() {
      if (this.$store.state.backOffice.steps.maxAudience == 0) {
        return 500
      }

      /*if(this.currentPlan.planTiers.maxAudienceRecipients > this.$store.state.backOffice.steps.maxAudience){
        return this.currentPlan.planTiers.maxAudienceRecipients
      }*/

      return this.$store.state.backOffice.steps.maxAudience
    },
    isOrganizationPlanSuspended() {
      return this.$route.query.suspendedPlan
    },
  },
}
</script>

<style lang="scss" scoped>
.h-30 {
  height: 30px;
}
</style>

<style lang="scss">
.btn:disabled,
.btn.disabled {
  background-color: white !important;
}
// .blockPlans {
// }
.blockPlanDetails {
  background-color: #fff;
  min-height: 580px;
  max-width: 330px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 20px 25px;
}

.blockPlanRecommendedDetails {
  background-color: #fff;
  min-height: 580px;
  max-width: 330px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 20px 25px;
  border: 2px solid #403266;
  position: relative;
}

.recommended {
  background-color: #403266;
  width: 45%;
  height: 28px;
  position: absolute;
  right: -2px;
  top: -1px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  border-top-right-radius: 10px 10px;
  border-bottom-left-radius: 10px 10px;
  line-height: 2.3;
  text-transform: uppercase;
}

.blockTitle {
  color: #343a40;
  font-size: 22px;
  font-weight: bold;
}

.blockSubTitle {
  color: #343a40;
  font-size: 27px;
  font-weight: bold;
  line-height: 1.1;
}

.blockSaveInfo {
  color: #868e96;
  font-size: 16px;
  line-height: 1.4;
}

.btnCurrentPlan {
  background-color: #fff !important;
  border-radius: 5px !important;
  border: 1px solid #adb5bd !important;
  color: #adb5bd !important;
  width: 100% !important;
  height: 40px !important;
}

.btnOptionPlan {
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #403266;
  color: #403266;
  width: 100%;
  height: 40px;
}

.btnRecommendedPlan {
  background-color: #403266;
  border-radius: 5px;
  color: #fff;
  width: 100%;
  height: 40px;
  border: 1px solid #403266;
}

.blockFeatureTitle {
  color: #343a40;
  font-size: 13px;
  font-weight: 700;
}

.blockFeatures {
  font-size: 13px;
}

.checkMark {
  color: #403266;
}

.refused {
  color: #868e96;
}
</style>
